import React from "react";
import {
  ToggleDescription,
  ToggleHeader,
} from "scripts/apps/importer/common/importer-styled-components";
import ErrorLogger from "utils/error-logger";
import { Checkbox } from "@evertrue/et-components/dist/index";
import { GateContext } from "apps/dna/gate-context";
import { toggleGate } from "../utils/api-requests";

const GateButtons = () => {
  const { gates = {}, loading, reload } = React.useContext(GateContext);

  const isGateEnabled = (gate) => {
    return gates && gates[gate] && gates[gate].enabled;
  };

  const gateDirectory = {
    signal: "Signal",
    cadences: "Cadences",
    task_management: "Task Management",
    outreach_email: "Outreach Email",
  };

  const toggleGateChecked = (gate) => {
    try {
      toggleGate(gate, !isGateEnabled(gate)).then(() => {
        reload();
      });
    } catch (error) {
      ErrorLogger.error(`There was an issue updating ${gateDirectory[gate]}.`);
    }
  };

  return (
    <div>
      <div style={{ margin: "20px", width: "200px" }}>
        <ToggleHeader>Gates</ToggleHeader>
        <ToggleDescription>
          Checking each relevant Signal gate below will toggle that Signal
          feature on for this organization. Unchecking will toggle that Signal
          feature off for this organization.
        </ToggleDescription>
        {Object.keys(gateDirectory).map((gate) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "10px",
            }}
            key={gate}
          >
            <div>{gateDirectory[gate]}</div>
            <Checkbox
              id={gate}
              checked={isGateEnabled(gate) || false}
              onChange={() => toggleGateChecked(gate)}
              label={gateDirectory[gate]}
              disabled={loading}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GateButtons;
